type ChartRingIconProps = {
  className?: string;
};

export default function ChartRingIcon({ className }: ChartRingIconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="10" cy="10" r="6.5" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="10" cy="10" r="2.5" fill="currentColor" />
    </svg>
  );
}
